<template>
	<v-btn v-if="isVisible" :small="small"
		   :text="withText"
		   :icon="!withText"
		   :title="title"
		   :disabled="disabled||!hasFullAccessToTask(item)"
		   class="deadline" :class="componentClass"
		   @click="onClick">
		<avatar v-if="isOverdueForMe" :user="this.user"
				icon="mdi-crown-outline"
				icon-color="red"
				title="Вы контроллер просроченной задачи"/>
		<v-icon v-else :small="large" :x-small="small" :left="withText">{{ icon }}</v-icon>
		<span v-if="withText" class="ml-1 text-none" :class="{caption:!large}">{{ deadline.text }}</span>
	</v-btn>
</template>

<script>
import Base from "@/mixins/base";
import {end} from "@/utils/string";
import {iso2Date, iso2DDMMYYYY} from "@/utils/date";
import {deadlineTextAndCss, isTaskOverdue, isTaskWithDeadlineDays, prioIconOf, PRIOS, prios, statuses} from "@/utils/task";
import vp from "@/mixins/vp";
import Assignee from "@/components/elements/assignee";

export default {
	name: "deadline",
	mixins: [Base, vp],
	components: {Assignee},
	props: {
		item: {},
		large: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		/**
		 * Не сохранять задачу сразу, а только вернуть выбранное значение через событие "change"
		 */
		/**
		 * Показывать как текстовую кнопку (иконка + текст дедлайна) вместо кнопки-иконки
		 */
		withText: {
			type: Boolean,
			default: false
		},
		skipUpdate: {
			type: Boolean,
			default: false
		},
		forced: {
			type: Boolean,
			default: false
		},
	},
	data: () => ({
		dialogCalendar: {
			isVisible: false,
		}
	}),
	computed: {
		isVisible() {
			if (!this.hasFullAccessToTask(this.item) && !this.item.deadline) return false;
			return this.isTaskActive(this.item)
				&& (!!this.item.deadline
					|| (isTaskWithDeadlineDays(this.item) && !!this.item.deadlineDays))
				|| this.forced;
		},
		icon() {
			//const prioItem = prios.find(el=>el.id === PRIOS.DEADLINE);
			if (isTaskOverdue(this.item)) return prioIconOf({
				...this.item,
				prio: PRIOS.DEADLINE,
				deletedAt: null,
				doneAt: null,
				isActive: true
			});
			return "mdi-timer-outline";
		},
		hasDeadline() {
			if (this.isTaskDone(this.item)) return false;
			if (this.item.isNote) return false;
			return (isTaskWithDeadlineDays(this.item) && this.item.deadlineDays)
				|| this.item.deadline;
		},
		isOverdueForMe() {
			return this.item.ownerId === this.user?.id && this.isTaskOverdue(this.item);
		},
		deadline() {
			return deadlineTextAndCss(this.item);
		},
		title() {
			return this.deadline.text;
		},
		componentClass() {
			const c = [];
			if (this.small) c.push("--small");
			if (this.deadline.css) c.push(this.deadline.css);
			//else c.push("grey--text")
			return c.length ? c : null;
		}
	},
	methods: {
		async onClick() {
			const res = await this.showDialogTaskDeadline(this.item, this.skipUpdate);
			if (res && this.skipUpdate) this.$emit("change", res);
		},
	}
}
</script>

<style lang="scss">
.deadline {
	&.v-btn {
		position: relative;
		text-indent: 0 !important;
	}
}
</style>